export default "__VITE_ASSET__CgLsF8D8__"